/**
 * Gainable Web Components
 *
 * Central export file for all Gainable components.
 * This is the main entry point for the bundle.
 *
 * Usage in browser (after including SortableJS):
 * <script src="https://components.gainable.dev/v1/gainable.js"></script>
 *
 * Components auto-register when this script loads.
 */

// Kanban components
export * from './kanban/index.js';

// Log registration for debugging
console.log('[Gainable Components] Registered: g-kanban, g-column, g-card');
